import type { FieldsetDesignTokens, FieldsetTokenSections } from '@openng/optimus-ui-themes/types/fieldset';

export const root: FieldsetTokenSections.Root = {
	padding: '1.125rem 1.125rem 1.125rem 1.125rem',
};

export const legend: FieldsetTokenSections.Legend = {
	borderWidth: '1',
};

export default {
	root,
	legend,
} satisfies FieldsetDesignTokens;
